import PropTypes from 'prop-types';
import { getTarget, targetPropType } from './utils';

var PopperTargetHelper = function PopperTargetHelper(props, context) {
  context.popperManager.setTargetNode(getTarget(props.target));
  return null;
};

PopperTargetHelper.contextTypes = {
  popperManager: PropTypes.object.isRequired
};
PopperTargetHelper.propTypes = {
  target: targetPropType.isRequired
};
export default PopperTargetHelper;


//////////////////
// WEBPACK FOOTER
// ../reactstrap/es/PopperTargetHelper.js
// module id = 1447
// module chunks = 25